import { useNavigateBack } from '@iheartjane/menu';
import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import type { RootLoaderType } from '@jane/kiosk/data-access/lib/loaders/rootLoader';

import { useTypedRouteLoaderData } from './useTypedRouteLoaderData';

export const usePdpModalClose = () => {
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { pathname } = useLocation();
  const [queryParams] = useSearchParams();
  const pdpDepth = queryParams.get('pdpDepth');

  const goBack = useNavigateBack(`/stores/${storeId}/menu/all`);

  const onModalClose = useCallback(() => {
    // If the product detail page is opened from the search modal page,
    // we go back to the search modal rather than all the way to the menu
    if (pathname.includes('search') && !pathname.includes('search-results')) {
      goBack(Number(pdpDepth) - 1);
    } else {
      goBack(Number(pdpDepth));
    }
  }, [pdpDepth, pathname, goBack]);

  return { onModalClose, pdpDepth };
};
